const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-371 -754)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 32,
  height: 32,
  transform: "translate(371 754)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-120.299 689.918)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(498.618 64.082)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M519.274,96.082H497.255a.43.43,0,0,1,0-.859h21.591V70.17l-5.23-5.229H497.685v9.345a.429.429,0,1,1-.858,0V64.512a.429.429,0,0,1,.428-.43h16.538a.429.429,0,0,1,.3.127l5.481,5.481a.43.43,0,0,1,.125.3v25.66A.43.43,0,0,1,519.274,96.082Z",
  transform: "translate(-496.827 -64.082)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.531 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M513.707,70.422h-5.488a.426.426,0,0,1-.3-.127.418.418,0,0,1-.125-.3l.008-5.481a.429.429,0,0,1,.733-.3l5.481,5.481a.43.43,0,0,1-.3.733Zm-5.058-.859h4.023l-4.017-4.015Z",
  transform: "translate(-507.791 -64.082)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.335 5.912)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M507.874,68.861h-8.406a.429.429,0,1,1,0-.858h8.406a.429.429,0,1,1,0,.858Z",
  transform: "translate(-499.039 -68.003)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 3.863)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M514.816,71.424H499.469a.43.43,0,1,1,0-.859h15.347a.43.43,0,1,1,0,.859Z",
  transform: "translate(-499.039 -70.565)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.011 7.727)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M512.792,73.986h-9.337a.429.429,0,0,1,0-.858h9.337a.429.429,0,1,1,0,.858Z",
  transform: "translate(-503.026 -73.128)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.011 11.591)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M512.792,76.549h-9.337a.429.429,0,0,1,0-.858h9.337a.429.429,0,1,1,0,.858Z",
  transform: "translate(-503.026 -75.691)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.011 15.454)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M512.792,79.112h-9.337a.43.43,0,0,1,0-.859h9.337a.43.43,0,1,1,0,.859Z",
  transform: "translate(-503.026 -78.253)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(6.011 19.319)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M512.792,81.674h-9.337a.429.429,0,0,1,0-.858h9.337a.429.429,0,1,1,0,.858Z",
  transform: "translate(-503.026 -80.816)"
})))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(493.299 75.289)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M506.585,77.2H493.729a.429.429,0,0,1-.43-.43V71.945a.429.429,0,0,1,.43-.43h12.856a.43.43,0,0,1,.43.43v4.829A.43.43,0,0,1,506.585,77.2Zm-12.428-.858h12V72.373h-12Z",
  transform: "translate(-493.299 -71.515)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 4.831)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M506.585,88.433H493.729a.428.428,0,0,1-.43-.428V75.147a.428.428,0,0,1,.43-.428h12.856a.429.429,0,0,1,.43.428V88.005A.429.429,0,0,1,506.585,88.433Zm-12.428-.858h12v-12h-12Z",
  transform: "translate(-493.299 -74.719)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 4.831)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M493.729,88.433a.428.428,0,0,1-.43-.428V75.147a.429.429,0,0,1,.858,0V88.005A.428.428,0,0,1,493.729,88.433Z",
  transform: "translate(-493.299 -74.719)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.285 4.831)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M496.571,88.433a.429.429,0,0,1-.43-.428V75.147a.43.43,0,0,1,.859,0V88.005A.429.429,0,0,1,496.571,88.433Z",
  transform: "translate(-496.141 -74.719)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.571 4.831)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M499.414,88.433a.428.428,0,0,1-.43-.428V75.147a.429.429,0,0,1,.858,0V88.005A.428.428,0,0,1,499.414,88.433Z",
  transform: "translate(-498.984 -74.719)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(12.856 4.831)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M502.256,88.433a.429.429,0,0,1-.43-.428V75.147a.43.43,0,0,1,.859,0V88.005A.429.429,0,0,1,502.256,88.433Z",
  transform: "translate(-501.826 -74.719)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 4.831)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M506.585,75.577H493.729a.429.429,0,1,1,0-.858h12.856a.429.429,0,1,1,0,.858Z",
  transform: "translate(-493.299 -74.719)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 9.116)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M506.585,78.42H493.729a.43.43,0,1,1,0-.859h12.856a.43.43,0,0,1,0,.859Z",
  transform: "translate(-493.299 -77.561)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.001 13.401)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M502.3,81.262H493.73a.43.43,0,0,1,0-.859H502.3a.43.43,0,1,1,0,.859Z",
  transform: "translate(-493.3 -80.403)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 17.687)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M506.585,84.1H493.729a.429.429,0,1,1,0-.858h12.856a.429.429,0,1,1,0,.858Z",
  transform: "translate(-493.299 -83.246)"
})))));
function SvgIconTables(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTables);
export default __webpack_public_path__ + "static/media/icon-tables.8efde9ad437a694e46e8ab3066dedf9e.svg";
export { ForwardRef as ReactComponent };